import { render } from "./PopupShareReportDashboard.vue?vue&type=template&id=1ae637d4"
import script from "./PopupShareReportDashboard.vue?vue&type=script&lang=js"
export * from "./PopupShareReportDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__